export const getNotification = ({ notification }) => notification;
